<div class="card-body">
    <div class="det-details">
        <div class="ibox-title report_flexweb">
            <div>
                <h5>Course Track Details</h5>
            </div>
            <div>
                <figure>
                    <img src="../../assets/image/Group 28269.svg" [mat-dialog-close]="true" />
                </figure>
            </div>
        </div>
        <!-- <mat-divider></mat-divider> -->
        <hr class="line">
        <div class="box2">
            <form [formGroup]="CourseTrack">
                <div class="example-card" *ngIf="data">
                    <div class="box">
                        <div class="campus_dtl">
                            <h3 class="course">course Track</h3>
                            <h3 class="name">{{data.courseTrackName}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">Code</h3>
                                <h3 class="name">{{data.courseTrackCode}}</h3>

                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">className</h3>
                            <h3 class="name">{{data.className}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">medium</h3>
                                <h3 class="name">{{data.medium}}</h3>
                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">groupName</h3>
                            <h3 class="name">{{data.groupName}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">orientation</h3>
                                <h3 class="name">{{data.orientation}}</h3>
                            </div>
                        </div>
                        <div class="campus_dtl">
                            <h3 class="course">trackType
                            </h3>
                            <h3 class="name">{{data.trackType}}</h3>
                        </div>
                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">streamName</h3>
                                <h3 class="name">{{data.streamName}}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">coachingType</h3>
                            <h3 class="name">{{data.coachingType}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">status</h3>
                                <h3 class="name">{{data.status}}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">createdOn</h3>
                            <h3 class="name">{{data.createdOn}}</h3>
                        </div>

                        <div class="color_1">
                            <div class="campus_dtl">
                                <h3 class="course">createdBy</h3>
                                <h3 class="name">{{data.createdBy}}</h3>
                            </div>
                        </div>

                        <div class="campus_dtl">
                            <h3 class="course">designation</h3>
                            <h3 class="name">{{data.designation}}</h3>
                        </div>
                    </div>
                </div>
                <div *ngIf="data.approvalStatus=='PENDING'">
                    <label for="" class="cctv_label">Remarks(optional)</label>
                    <input type="text" class="form-control" id="" placeholder="Any Other Reason(s)"
                        formControlName="anyOtherReasons">
                </div>
            </form>
        </div>
        <hr class="line">
        <div class="button" *ngIf="data.approvalStatus=='PENDING'">
            <button class="approval" (click)="approval(data)">approval</button>
            <button class="rejected" (click)="reject(data)">Rejected</button>
        </div>
    </div>
</div>


<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>